import PropTypes from "prop-types";

const deal = {
  id: PropTypes.number.isRequired,
  activityLevelColor: PropTypes.string,
  asset: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
  }),
  portfolio: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  lastItem: PropTypes.shape({
    user: PropTypes.shape({
      fname: PropTypes.string.isRequired,
      lname: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      deleted: PropTypes.bool,
    }),
    content: PropTypes.string,
  }),
  creator: PropTypes.shape({
    id: PropTypes.number,
    fname: PropTypes.string,
    lname: PropTypes.string,
  }),
  emailToken: PropTypes.string,
  name: PropTypes.string.isRequired,
  pointPerson: PropTypes.shape({
    fname: PropTypes.string.isRequired,
    lname: PropTypes.string.isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired, // eslint-disable-line
    }),
  }),
  shareStatus: PropTypes.string.isRequired,
  size: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
    unit: PropTypes.string,
  }),
  totalSharedBrokers: PropTypes.number,
  viewings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      createdAt: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      createdAt: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  files: PropTypes.arrayOf(PropTypes.object),
  systemEvents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      createdAt: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  term: PropTypes.shape({
    amount: PropTypes.number,
    duration: PropTypes.oneOf(["months", "years"]),
  }),
  spaceCategories: PropTypes.arrayOf(PropTypes.string),
  budgetPeriod: PropTypes.string,
};

export default deal;
